import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_012972d9";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_012972d9" };
/** script content **/
require("./date-picker-popup.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex012972d9%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fdate-picker-popup%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_012972d9"],
    ctorType: "component",
    outputPath: "components/index012972d9/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-popup-base': getComponent(require("../picker-popup/picker-popup-base.mpx?isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex")), 'cube-date-picker': getComponent(require("../date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
